import React from "react";

import { Row, Col } from "react-flexbox-grid";
import { TextField } from "components/support";
import { observer } from "mobx-react";

import style from "./style";

const AdditionalMessageReceipt = ({ className, company, onChange }) => (
  <Row className={className}>
    <Col xs={12} md={6}>
      <TextField
        fullWidth
        multiLine
        floatingLabelFixed
        floatingLabelText="Mensagem Adicional dos Recibos"
        value={
          company.receipt_additional_message
            ? company.receipt_additional_message
            : null
        }
        onChange={(_, value) => onChange(value)}
      />
    </Col>
    <Col xs className="template-info">
      <p className="text-justify">
        A mensagem adicional de recibos é a mensagem apresentada na parte
        inferior impressa do comprovante. Por exemplo:
      </p>
      <p className="text-justify">
        Para acompanhar seu pedido, acesse: http://www.exemplo.com/pedidos
      </p>
    </Col>
  </Row>
);

export default style(observer(AdditionalMessageReceipt));



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/config-app/additional-message-config/index.jsx